<template>
  <canvas ref="canvas" />
</template>

<script setup lang="ts">
  import { onMounted, Ref, ref, watch } from 'vue';

  import { ICoordinates } from './DaypartGrid.vue';

  interface ISelectionBoxProps {
    startPosition: ICoordinates;
    currentPosition: ICoordinates;
    pixelRatio: number;
  }

  const props = defineProps<ISelectionBoxProps>();

  const canvas: Ref<HTMLCanvasElement> = ref();

  function clearCanvas() {
    const ctx = canvas.value.getContext('2d');
    ctx.clearRect(0, 0, canvas.value.width, canvas.value.height);
  }

  function drawSelectionBox() {
    clearCanvas();
    const ctx = canvas.value.getContext('2d');
    if (props.startPosition != null) {
      canvas.value.width = canvas.value.offsetWidth * props.pixelRatio;
      canvas.value.height = canvas.value.offsetHeight * props.pixelRatio;
      ctx.strokeStyle = '#777';
      ctx.setLineDash([5, 3]);
      ctx.strokeRect(
        props.startPosition.x * props.pixelRatio,
        props.startPosition.y * props.pixelRatio,
        (props.currentPosition.x - props.startPosition.x) * props.pixelRatio,
        (props.currentPosition.y - props.startPosition.y) * props.pixelRatio,
      );
    }
  }

  watch(
    () => props.currentPosition,
    () => drawSelectionBox(),
  );

  onMounted(() => clearCanvas());
</script>

<style scoped lang="scss">
  canvas {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
</style>
